
export default {
  name: "back-to-home",
};
